import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-transfer-warning-dialog',
  imports: [],
  templateUrl: './transfer-warning-dialog.component.html',
  styleUrl: './transfer-warning-dialog.component.scss',
})
export class TransferWarningDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<TransferWarningDialogComponent>
  ) {}

  closeDialog(action: string): void {
    this.dialogRef.close(action);
  }
}
